/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1607
 */

"use strict"

var r = require(/* 86 */"./1650/86/index")
var /* [auto-meaningful-name] */require_828_$_1761_828$includes = require(/* 828 */"./1761/828").includes
var i = require(/* 637 */"./1598/637")
r({
  target: "Array",
  proto: true
}, {
  includes: function (e) {
    return require_828_$_1761_828$includes(this, e, arguments.length > 1 ? arguments[1] : undefined)
  }
})
i("includes")
